import React, { useEffect, useState } from 'react';
import { useLocation, useParams } from 'react-router-dom';
import { BreadCrumb } from 'primereact/breadcrumb';
import _ from 'lodash';
import { Button } from "react-bootstrap";
import searchMyProjectsClicked from "../../../assets/images/searchMyProjectsClicked.svg";
import searchMyProjects from '../../../assets/images/searchMyProjects.svg';
import ExportSelectedRows from '../../ExportCSV';
import filter from '../../../assets/images/filter.svg';
import BlueFilterIcon from '../../../assets/images/BlueFilterIcon.svg';
import { CustomBreadCrum } from "../../common/CustomBreadcrum";
import WrapIcon from '../../../assets/images/wrap-icon.png';
import ChangeHandling from '.';

const ChangeHandlingHeader = (props) => {
  const {
    isSearch = false,
    clearFilter,
    onSearchClick,
    allData,
    headers,
    filename,
    selectedRows,
    isFilterEnabled,
    setVisible,
    onChildClick,
    chwrapFreeText,
    setchWrapFreeText,
    historywrapFreeText,
    setHistoryWrapFreeText,
    onRefreshPOA,
    refreshPOLoading,
    onGetHistoryData,
    historyLoading,
    filterFLag,
    checkboxSelected,
    navigationState, // <-- add this prop
    onShowAllClick
  } = props;

  const location = useLocation();
  const [state, updateState] = useState([]);
  const { ProjectID, id } = useParams();
  let currentUrl = '';
  const items = [];
  const [isClicked, setIsClicked] = useState(isSearch);
  const [isfilterClicked, setIsFilterClicked] = useState(false);

  const handleClick = () => {
    const newIsClicked = !isClicked;
    setIsClicked(newIsClicked);
    onSearchClick();
    if (onChildClick) {
      onChildClick(newIsClicked, "changeHandling");
    }
  };

  const handleClearFilter = () => {
    const newIsClicked = !isFilterEnabled;
    setIsClicked(newIsClicked);
    setIsFilterClicked(newIsClicked);
    clearFilter();
    if (onChildClick) {
      onChildClick(newIsClicked, "changeHandling");
    }
  };

  const getUrl = (e) => {
    switch (e) {
      case 'allProjects':
        return (currentUrl = `${currentUrl}/${e}`);
      case 'myProjects':
        return (currentUrl = `${currentUrl}/${e}`);
      case 'projectPlan':
        return (currentUrl = `${currentUrl}/${e}/${ProjectID}`);
      case 'task':
        return (currentUrl = `${currentUrl}/${e}/${id}`);
      case 'artworkAlignment':
        // Construct proper artwork alignment URL based on current path
        const currentPath = location.pathname;
        if (currentPath.includes("/DSBP/tab/artworkAlignment/ChangeHandling/")) {
          // For DSBP tab pattern: remove ChangeHandling and assignee, keep ProjectID
          const baseUrl = currentPath.replace(/\/ChangeHandling\/[^\/]+/, "");
          return (currentUrl = baseUrl);
        } else if (currentPath.includes("/artworkAlignment/ChangeHandling/")) {
          // For direct pattern: remove just ChangeHandling
          const baseUrl = currentPath.replace("/ChangeHandling", "");
          return (currentUrl = baseUrl);
        }
        // Fallback to default construction
        return (currentUrl = `${currentUrl}/${e}`);
      default:
        currentUrl = `${currentUrl}/${e}`;
    }
  };

  useEffect(() => {
    const fromDependencyMapping = navigationState?.from === "dependencyMappingPage";
    const fromArtworkStatus = navigationState?.from === "artworkstatusPage";
    const fromArtworkAlignment = navigationState?.from === "artworkalignmentpage";
    const fromNotification = navigationState?.from === "notification";
    
    if ((fromDependencyMapping || fromArtworkStatus || fromArtworkAlignment) && navigationState?.previousUrl) {
      // Create custom breadcrumb based on the source page
      const previousUrl = navigationState.previousUrl;
      
      // Determine the parent section based on the previous URL
      let parentLabel = "My Tasks";
      let parentUrl = "/myTasks";
      
      if (previousUrl.includes("/myProjects/")) {
        parentLabel = "My Projects";
        parentUrl = "/myProjects";
      } else if (previousUrl.includes("/allProjects/")) {
        parentLabel = "All Projects";
        parentUrl = "/allProjects";
      } else if (previousUrl.includes("/allTasks/")) {
        parentLabel = "All Tasks";
        parentUrl = "/allTasks";
      } else if (previousUrl.includes("/capacityManagement/")) {
        parentLabel = "Capacity Management";
        parentUrl = "/capacityManagement";
      }
      
      // Determine the middle breadcrumb label based on the source
      let middleLabel = "Dependency Mapping";
      if (fromArtworkStatus) {
        middleLabel = "Artwork Status";
      } else if (fromArtworkAlignment) {
        // Check if it's DSBP tab or direct artwork alignment
        if (previousUrl.includes("/DSBP/tab/artworkAlignment/")) {
          middleLabel = "Artwork Alignment";
        } else {
          middleLabel = "Artwork Alignment";
        }
      } else if (fromDependencyMapping) {
        // Check if it's DSBP tab or direct dependency mapping
        if (previousUrl.includes("/DSBP/tab/dependencyMapping/")) {
          middleLabel = "Dependency Mapping";
        } else {
          middleLabel = "Dependency Mapping";
        }
      }
      
      const customItems = [
        {
          label: parentLabel,
          url: parentUrl
        },
        {
          label: middleLabel,
          url: previousUrl
        },
        {
          label: "Change Handling",
          template: () => {
            return <span className="lastElement">Change Handling</span>;
          }
        }
      ];
      updateState(customItems);
    } else {
      // Use the existing logic for other navigation paths
      location.pathname
        ?.split('/')
        .filter((home) => {
          return home !== '' && home !== ProjectID && home !== id;
        })
        .forEach((ele, i, arr) => {
          const obj = {};

          if (arr.length - 1 === i) {
            items.push({
              ...obj,
              label: _.startCase(ele),
              url: getUrl(ele),
              template: () => {
                return <span className="lastElement">{_.startCase(ele)}</span>;
              },
            });
          } else {
            items.push({ ...obj, label: _.startCase(ele), url: getUrl(ele) });
          }
        });
      updateState(items);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location, navigationState]);

  return (
    <div className="actions-changeHandling">
      {/* <BreadCrumb model={state} separatorIcon={<i className="pi pi-angle-right"></i>} /> */}
      {/* making use of reusable components which give me option to just pass the items and those are customizable */}
      <CustomBreadCrum 
        items={state} 
        lastLabel={"Change Handling"}
        iconColorBlack={true}
        lastChildSecondChild={false}
      />
      <div className='actionButtons'>
        <div className='icon-header me-4'>
          {/* Wrap/Unwrap Icon before Confirm Full Scope in */}
          <img
            src={WrapIcon}
            alt={
              historywrapFreeText !== undefined
                ? (historywrapFreeText ? "Unwrap Free Text" : "Wrap Free Text")
                : (chwrapFreeText ? "Unwrap Free Text" : "Wrap Free Text")
            }
            title={
              historywrapFreeText !== undefined
                ? (historywrapFreeText ? "Unwrap Free Text Columns" : "Wrap Free Text Columns")
                : (chwrapFreeText ? "Unwrap Free Text Columns" : "Wrap Free Text Columns")
            }
            onClick={() => {
              if (historywrapFreeText !== undefined && setHistoryWrapFreeText) {
                setHistoryWrapFreeText((prev) => !prev);
              } else if (setchWrapFreeText) {
                setchWrapFreeText((prev) => !prev);
              }
            }}
            className='wrapIconHistory'
            style={{
              filter: (historywrapFreeText !== undefined ? historywrapFreeText : chwrapFreeText) ? "none" : "grayscale(100%)"
            }}
          />
          {/* Add your Confirm Full Scope in button here if needed */}
          <img
            alt="filter"
            hidden={filterFLag}
            onClick={isFilterEnabled ? handleClearFilter : undefined}
            className={isFilterEnabled ? "header-icons filter-active" : "filter-inactive"}
            src={isFilterEnabled ? BlueFilterIcon : filter}
            style={{
              cursor: isFilterEnabled ? "pointer" : "default",
              height: "20px"
            }}
          />
          <img
            src={isClicked ? searchMyProjects : searchMyProjectsClicked}
            alt="search field"
            onClick={handleClick}
            className="header-icons"
          />
          <>
            <ExportSelectedRows
              selectedRows={selectedRows}
              allData={allData}
              headers={headers}
              filename={filename}
            />
          </>
          </div>
        <div className="action-button-changeHandling">
          <Button
            variant="secondary"
            className="button-layout"
            onClick={setVisible}
          >
            Customize View
          </Button>
          {<Button
            variant="secondary"
            className="button-layout"
            type="button"
            onClick={onRefreshPOA}
            tabIndex={0}
          >
            Refresh POA
          </Button>}
          <Button
            variant="secondary"
            className="button-layout"
            type="button"
            onClick={onGetHistoryData}
            disabled={historyLoading}
          >
            Historical Data
          </Button>
          <Button
            variant="secondary"
            className="button-layout"
            type="button"
            onClick={onShowAllClick}
            disabled={historyLoading}
          >
            Show All
          </Button>
        </div>
      </div>
    </div>
  );
};
export default ChangeHandlingHeader;
